/**
 * Monthly Price
 */
 const MonthlyPlan =  [
    {
        id : 1,
        title :"Basic Plan",
        subTitle :"For Startup",
        icon: "ri-book-mark-line",
        rate : 19,
        projects : 3,
        Customers :"299",
        band :'Scalable Bandwidth',
        FTP:5,
        supportClass:"danger",
        supportClassSymbol :"close",
        storageClass :"danger",
        storageClassSymbol :"close",
        domainClass :"danger",
        domainClassSymbol :"close",
        ribbon:false,
    },
    {
        id : 2,
        title :"Pro Business",
        subTitle :"Professional plans",
        icon: "ri-medal-fill",
        rate : 29,
        projects : 15,
        Customers :"Unlimited",
        band :'Scalable Bandwidth',
        FTP:12,
        supportClass:"success",
        supportClassSymbol :"checkbox",
        storageClass :"danger",
        storageClassSymbol :"close",
        domainClass :"danger",
        domainClassSymbol :"close",
        ribbon:true,
    },
    {
        id : 3,
        title :"Platinum Plan",
        subTitle :"Enterprise Businesses",
        icon: "ri-stack-fill",
        rate : 39,
        projects : "Unlimited ",
        Customers :"Unlimited",
        band :'Scalable Bandwidth',
        FTP:"Unlimited ",
        supportClass:"success",
        supportClassSymbol :"checkbox",
        storageClass :"success",
        storageClassSymbol :"checkbox",
        domainClass :"success",
        domainClassSymbol :"checkbox",
        ribbon:false,
    },
]

/**
 * Monthly Price
 */
 const AnnualPlan =  [
    {
        id : 1,
        title :"Basic Plan",
        subTitle :"For Startup",
        icon: "ri-book-mark-line",
        rate : 171,
        projects : 3,
        Customers :"299",
        band :'Scalable Bandwidth',
        FTP:5,
        supportClass:"danger",
        supportClassSymbol :"close",
        storageClass :"danger",
        storageClassSymbol :"close",
        domainClass :"danger",
        domainClassSymbol :"close",
        ribbon:false,
    },
    {
        id : 2,
        title :"Pro Business",
        subTitle :"Professional plans",
        icon: "ri-medal-fill",
        rate : 261,
        projects : 15,
        Customers :"Unlimited",
        band :'Scalable Bandwidth',
        FTP:12,
        supportClass:"success",
        supportClassSymbol :"checkbox",
        storageClass :"danger",
        storageClassSymbol :"close",
        domainClass :"danger",
        domainClassSymbol :"close",
        ribbon:true,
    },
    {
        id : 3,
        title :"Platinum Plan",
        subTitle :"Enterprise Businesses",
        icon: "ri-stack-fill",
        rate : 351,
        projects : "Unlimited ",
        Customers :"Unlimited",
        band :'Scalable Bandwidth',
        FTP:"Unlimited ",
        supportClass:"success",
        supportClassSymbol :"checkbox",
        storageClass :"success",
        storageClassSymbol :"checkbox",
        domainClass :"success",
        domainClassSymbol :"checkbox",
        ribbon:false,
    },
]
  
  export { MonthlyPlan, AnnualPlan };
  